import axios from "../../utils/axios";

// 数据查询 
export function getList (query) {   
    return axios({  
        url: "hp/getHp",        
        method: "get",      
        params: query   
    }); 
}   

// 数据查询
export function getInits (query) {
    return axios({
        url: "hp/getHp",
        method: "get",
        params: query
    });
}



